import * as React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function ConfirmDialog(props) {
    const { translate, obj } = props;

    return (
        <Dialog
            open={obj?.open}
            onClose={obj?.onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ textAlign: "left" }}
        >
            <DialogTitle id="alert-dialog-title" sx={{ textAlign: "left" }}>
                {obj?.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {obj?.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color='inherit' onClick={obj?.onClose}>{translate('cancel')}</Button>
                <Button onClick={obj?.onAgree} autoFocus>
                    {obj?.buttonName}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default withTranslate(ConfirmDialog)